module.exports = __webpack_public_path__ + "static/img/AgAABXq0GNeEQvCEX6BLq5-0Vk76EZfF.3d9f4c8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/套装/AgAABXq0GNeEQvCEX6BLq5-0Vk76EZfF.jpeg
// module id = Eadh
// module chunks = 0